export default __webpack_public_path__ + "static/media/icn-close.738f0e94.svg";